export default "__VITE_ASSET__BKfnAsf8__"